import React from "react";
import dynamic from "next/dynamic";
import { TrustedByBlock } from "../index";

// Dynamic imports
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"),{ssr: true});
import { toWebp } from "@/utils/common";
const TrustCardMain = dynamic(() => import("./TrustCardMain"), { ssr: true });

interface TrustedProps {
  data?: TrustedByBlock;
}

interface LogoItem {
  image?: any;
  title?: string;
}

const splitIntoColumns = <T,>(arr: T[], cols: number): T[][] => {
  const output: T[][] = Array.from({ length: cols }, () => []);
  arr.forEach((item, index) => {
    output[index % cols].push(item);
  });
  return output;
};

const GRID_BREAKPOINTS: { cols: number; visibilityClass: string }[] = [
  { cols: 2, visibilityClass: "grid sm:hidden" },
  { cols: 3, visibilityClass: "hidden sm:grid xl:hidden" },
  { cols: 4, visibilityClass: "hidden xl:grid" },
];

const Trusted: React.FC<TrustedProps> = ({ data }) => {
  const items =
    data?.logos?.map((logo: LogoItem) => ({
      logoSrc: toWebp(logo?.image?.data?.attributes?.url || ""),
      company: logo?.title || "",
    })) || [];

  if (!items?.length) return null;

  return (
    <Section>
      <div className="container">
        {data?.title && (
          <h2 className="text-heading-1 font-bold text-primary-text text-center">
            {data?.title}
          </h2>
        )}

        <div
          className="xl:mt-10 mt-8 relative
            after:content-[''] after:absolute after:w-full after:h-[20%] after:z-10 after:top-0 after:right-0 after:bg-[linear-gradient(180deg,_#FFFFFF_15%,_rgba(255,255,255,0)_100%)]
            before:content-[''] before:absolute before:w-full before:h-[20%] before:z-10 before:bottom-0 before:right-0 before:bg-[linear-gradient(360deg,_#FFFFFF_15%,_rgba(255,255,255,0)_100%)]"
        >
          <div className="min-h-[451px] md:min-h-[583px] lg:min-h-[640px] lg:max-h-[640px] md:max-h-[583px] max-h-[451px] overflow-hidden">
            {GRID_BREAKPOINTS.map(({ cols, visibilityClass }) => {
              const repeatedColumns = splitIntoColumns(items, cols).map(
                (col) => [...col, ...col]
              );
              return (
                <div
                  key={cols}
                  className={`${visibilityClass} md:gap-[30px] gap-6`}
                  style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
                >
                  {repeatedColumns.map((group, index) => (
                    <TrustCardMain
                      key={index}
                      className={index % 2 === 0 ? "marquee-down" : "marquee-up"}
                      classNameMain="flex-1"
                      items={group}
                    />
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Trusted;
